"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _Translations = require("react-platform-components/dist/Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var styles = function styles(theme) {
  return {
    cardShadow: {
      boxShadow: '4px 3px 20px #c7c7c7'
    }
  };
};
var ProductDetails = /*#__PURE__*/function (_React$Component) {
  _inherits(ProductDetails, _React$Component);
  var _super = _createSuper(ProductDetails);
  function ProductDetails(props) {
    var _this;
    _classCallCheck(this, ProductDetails);
    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }
  _createClass(ProductDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.dispatch({
        type: 'FETCH_PRODUCT_DETAILS',
        id: this.props.match.params.id
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        product = _this$props.product;
      return !product ? /*#__PURE__*/_react.default.createElement("div", null) : /*#__PURE__*/_react.default.createElement(_core.Paper, {
        className: (0, _classnames.default)('m-4 md:m-8', classes.cardShadow),
        style: {
          minHeight: '400px'
        }
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        spacing: 4,
        className: "p-4"
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 8
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "h4"
      }, " ", product.title, " ")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        container: true,
        justify: "flex-end",
        alignItems: "center",
        xs: 4
      }, /*#__PURE__*/_react.default.createElement(_core.Chip, {
        label: product.translated_status,
        color: product.status === 'published' ? 'primary' : 'default',
        variant: "outlined"
      })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "h4",
        className: "mb-6"
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Description",
        defaultMessage: "Description"
      })), /*#__PURE__*/_react.default.createElement(_core.Typography, null, " ", product.description, " ")))));
    }
  }]);
  return ProductDetails;
}(_react.default.Component);
var _default = (0, _core.withStyles)(styles)((0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    product: state.ProductDetailsReducer.product
  };
})(ProductDetails)));
exports.default = _default;